import { render, staticRenderFns } from "./Unternehmen.vue?vue&type=template&id=752dcbf0&scoped=true&"
import script from "./Unternehmen.vue?vue&type=script&lang=ts&"
export * from "./Unternehmen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752dcbf0",
  null
  
)

export default component.exports